import PropTypes from "prop-types";
import React from "react";

import Week from "react-big-calendar/lib/Week";
import TimeGrid from "react-big-calendar/lib/TimeGrid";

function workWeekRange(date, options) {
    /*let week = Week.range(date, options);
    let remain = week.filter(
        (d) => {
            console.log(d.getDay());
            return [1,2,3,4,5,6].indexOf(d.getDay()) === -1
        }
    );*/
    let remain = [new Date()]
    /*if (remain.length === 7) {
        return remain
    }*/
    let diff = 7 - remain.length;
    let ndate = new Date(remain[0].getTime());
    for (var i = 0; i < diff; i++) {
        ndate.setDate(ndate.getDate() + 1);
        remain.push(new Date(ndate.getTime()));
    }
    return remain
}

class MyWorkWeek extends React.Component {
    render() {
        let { date, ...props } = this.props;
        let range = workWeekRange(date, this.props);

        return <TimeGrid {...props} range={range} eventOffset={15} />;
    }
}

MyWorkWeek.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired
};

MyWorkWeek.defaultProps = TimeGrid.defaultProps;

MyWorkWeek.range = workWeekRange;

MyWorkWeek.navigate = Week.navigate;

MyWorkWeek.title = (date, { localizer }) => {
    let [start, ...rest] = workWeekRange(date, { localizer });

    return localizer.format({ start, end: rest.pop() }, "dayRangeHeaderFormat");
};

export default MyWorkWeek;
